var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"ccn-headline",class:[
    ("ccn-headline--" + _vm.size),
    { 'ccn-headline--border': _vm.border },
    { 'ccn-headline--clickable': _vm.clickable },
    { 'ccn-headline--no-spacing': _vm.noSpacing },
    { 'ccn-headline--uppercase': _vm.uppercase } ]},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }